<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- logo -->
        <div class="logo">
          <img
            v-if="bannerArr.length > 0"
            :src="$imgUrl + bannerArr[0].thumb"
            alt=""
          />
        </div>
        <!-- 内容区 -->
        <div class="apply-wrap">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            label-position="top"
            class="demo-ruleForm"
          >
            <el-form-item class="apply-title"
              >一、基本信息（必填）</el-form-item
            >
            <el-form-item label="企业名称（中文）" prop="ex_company_name">
              <el-input
                v-model="ruleForm.ex_company_name"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业名称（英文）" prop="ex_encompany_name">
              <el-input
                v-model="ruleForm.ex_encompany_name"
                placeholder="如果没有英文名称，写中文名称即可。"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业品牌归属地" prop="country_area">
              <el-cascader
                v-model="ruleForm.country_area"
                :options="options"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input
                v-model="ruleForm.contacts"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="职务" prop="duties">
              <el-input
                v-model="ruleForm.duties"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="mobile">
              <div class="apply-phone">
                <el-input
                  v-model="ruleForm.mobile"
                  placeholder="请填写"
                ></el-input>

                <el-button
                  class="code-btn"
                  :class="{ 'code-btn-dis': isClick }"
                  @click="getCode"
                  >{{ codeTxt }}</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input
                type="number"
                v-model="ruleForm.code"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="固话" prop="tel">
              <el-input v-model="ruleForm.tel" placeholder="请填写"></el-input>
            </el-form-item>
            <el-form-item label="传真">
              <el-input
                v-model="ruleForm.fax"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="ruleForm.email"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮编">
              <el-input
                v-model="ruleForm.postalcode"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="detail_address">
              <el-input
                v-model="ruleForm.detail_address"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业类别（单选）" prop="company_category">
              <el-radio-group v-model="ruleForm.company_category">
                <el-radio
                  v-for="(item, index) in companyCategory"
                  :key="index"
                  :label="item.name"
                ></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="展示范围及服务所属展区（可多选）"
              prop="nshowarea"
            >
              <el-checkbox-group v-model="ruleForm.nshowarea">
                <el-checkbox
                  v-for="(item, index) in showArea"
                  :key="index"
                  :label="item.name"
                  name="nshowarea"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="本单位参展BCEIA2025预订展位面积"
              prop="apply_area"
            >
              <el-input
                type="number"
                v-model="ruleForm.apply_area"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="您从什么渠道了解的BCEIA？" prop="channel">
              <el-input
                v-model="ruleForm.channel"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <div class="line"></div>
            <el-form-item class="apply-title"
              >二、其他信息（选填）</el-form-item
            >
            <el-form-item label="微信" prop="wxchat">
              <el-input
                v-model="ruleForm.wxchat"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="本单位（是/否）购买过BCEIA2021 或 BCEIA2023展位。（请选择）"
              prop="is_repeat"
            >
              <el-radio-group v-model="ruleForm.is_repeat">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="介绍人" prop="referee">
              <el-input
                v-model="ruleForm.referee"
                placeholder="本单位经（介绍人/单位）介绍意向参展BCEIA2025"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="请填写贵公司关注度高的行业媒体（网站、期刊杂志、微信订阅号等）"
              prop="media"
            >
              <el-input
                v-model="ruleForm.media"
                placeholder="请填写"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-collapse>
                <el-collapse-item title="我司将展示的展品和/或服务是属于以下展示范围中的(请打勾选取):" name="1">
                  <div class="checkBox">
                    <el-form-item v-for="(items,index) in lists" :key="index" :label="items.name_cn">
                      <el-checkbox-group v-model="checkList">
                        <el-checkbox  v-for="(item,idx) in items.children" :key="idx" :label="item.name_cn"></el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-form-item>
            <el-form-item>
            <el-collapse>
              <el-collapse-item title="我司的产品应用于以下行业(请打勾选取):" name="2">
                <div class="checkBox">
                  <el-checkbox-group v-model="industry" style="width: 100%">
                    <el-checkbox v-for="(item,idx) in industryList" :key="idx" :label="item.name_cn"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
            <el-form-item>
              <div class="apply-btn" @click="submitForm('ruleForm')">提交</div>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import {
  getBanner,
  getLocationTree,
  companyApply,
  getdict,
  getCode,
  getApplicationIndustry,
  getExhibitionScope
} from "@/api/api";
export default {
  components: { top, bottom },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "BCEIA-参展申请",
      meta: [
        {
          name: "description",
          content: "北京分析测试学术报告会暨展览会参展申请",
        },
      ],
    };
  },
  data() {
    return {
      lists:[],
      industryList:[],
      checkList:[],
      industry:[],
      countdown: 0,
      codeTxt: "获取验证码",
      timer: null,
      isClick: false,
      langSet: "",
      bannerArr: [],
      options: [],
      ruleForm: {
        ex_company_name: "",
        ex_encompany_name: "",
        country_area: [],
        contacts: "",
        duties: "",
        mobile: "",
        tel: "",
        email: "",
        detail_address: "",
        company_category: "",
        nshowarea: [],
        apply_area: "",
        channel: "",
        wxchat: "",
        referee: "",
        is_repeat: "否",
        media: "",
        code: "",
      },
      companyCategory: [],
      showArea: [],
      rules: {
        ex_company_name: [
          { required: true, message: "请填写", trigger: "blur" },
        ],
        ex_encompany_name: [
          {
            required: true,
            message: "请填写",
            trigger: "blur",
          },
        ],
        country_area: [{ required: true, message: "请填写", trigger: "blur" }],
        contacts: [{ required: true, message: "请填写", trigger: "blur" }],
        duties: [{ required: true, message: "请填写", trigger: "blur" }],
        mobile: [
          { required: true, message: "请填写", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        tel: [{ required: true, message: "请填写", trigger: "blur" }],
        email: [
          { required: true, message: "请填写", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        detail_address: [
          { required: true, message: "请填写", trigger: "blur" },
        ],
        company_category: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        nshowarea: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        apply_area: [{ required: true, message: "请填写", trigger: "blur" }],
        channel: [{ required: true, message: "请填写", trigger: "blur" }],
        code: [{ required: true, message: "请填写", trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getTree();
    this.getdictList();
    this.getExhibitionScopeList()
    this.getApplicationIndustryList()
  },
  beforeDestroy() {
    // 在组件销毁前清除计时器
    this.clearCountdown();
  },
  methods: {
    getExhibitionScopeList(){
      
      getExhibitionScope({})
        .then((res) => {
          if (res.code == 1) {
            this.lists = res.data.lists;
            
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getApplicationIndustryList(){
      
      getApplicationIndustry({})
        .then((res) => {
          if (res.code == 1) {
            this.industryList = res.data.lists;
            
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取展会服务banner
    getBannerList() {
      let data = {
        class: "参展流程",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // dxm 获取省市区
    getTree() {
      getLocationTree({})
        .then((res) => {
          if (res.code == 1) {
            this.options = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取字典数据
    getdictList() {
      getdict({
        type: "showarea,company_category",
      })
        .then((res) => {
          if (res.code == 1) {
            this.companyCategory = res.data.company_category;
            this.showArea = res.data.showarea;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCode() {
      let pattern = /^1[3-9]\d{9}$/;
      let data = {
        mobile: this.ruleForm.mobile,
        scene: "YZSJH",
      };
      if (!this.ruleForm.mobile) {
        this.$message.error("请输入手机号！");
      } else if (!pattern.test(this.ruleForm.mobile)) {
        this.$message.error("手机号码格式不正确！");
      } else {
        if (this.isClick) {
          return;
        }
        this.isClick = true;

        this.getCountdown();
        getCode(data)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("验证码已发送！请注意查收！");

              this.getCountdown();
            } else {
              this.$message.error("验证码发送失败！");
              this.isClick = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.isClick = false;
          });
      }
    },

    // 点击倒计时
    getCountdown() {
      this.countdown = 60;
      const startTime = Date.now(); // 记录倒计时开始时间
      const animate = () => {
        const currentTime = Date.now();
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < 60000) {
          // 60秒倒计时
          this.countdown = Math.floor((60000 - elapsedTime) / 1000);
          this.codeTxt = "重新获取" + this.countdown + "s";
          this.timer = requestAnimationFrame(animate);
        } else {
          this.clearCountdown();
        }
      };
      animate();
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
        this.codeTxt = "获取验证码";
        this.isClick = false;
        this.countdown = 60;
      }
    },
    //dxm 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.upData(this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //dxm 更新提交数据
    upData(data) {
      let scope=''
      let industry=''
      if(this.checkList.length>0){scope=this.checkList.join(",")}
      if(this.industry.length>0){industry=this.industry.join(",")}
      data.scope=scope;
      data.industry=industry;

      // 24.9.4 判断链接是否有来源，有就能链接的来源，没有就用缓存的来源 dxm
      if (this.$route.query.source) {
        data.source = this.$route.query.source;
      } else {
        data.source = localStorage.getItem("source") || "";
      }
      data.showarea = data.nshowarea + "";
      companyApply(data)
        .then((res) => {
          console.log(res, "===res");
          if (res.code == 1) {
            delete data.nshowarea;
            this.$router.push({
              path: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-checkbox {
    width: 28%;
    margin-bottom: 6px;
}
 /deep/ .el-collapse{
    border: none !important;
  }
  /deep/ .el-collapse-item__wrap{
    border: none !important;
  }
  /deep/ .el-collapse-item__header{
    border: none !important;
    font-size: 15px !important;
    font-weight: 600 !important;
  }
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.apply-wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 35px;
  .apply-title {
    /deep/ .el-form-item__content {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
    }
  }
  .line {
    width: 100%;
    height: 6px;
    margin-top: 30px;
    margin-bottom: 30px;
    background: #f5f5f5;
  }
  .el-form-item {
    width: 480px;
    margin: 0 auto 26px;
    .apply-btn {
      width: 242px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      background: linear-gradient(180deg, #4a69be 0%, #243889 100%);
      border-radius: 7px;
      margin: 35px auto 0;
      cursor: pointer;
      &:hover {
        background: #243889;
      }
    }
    .apply-phone {
      display: flex;
      .el-input {
        flex: 1;
      }
      .code-btn {
        width: 120px;
        height: 44px;
        padding: 0;
        color: #fff;
        font-size: 14px;
        text-align: center;
        line-height: 44px;
        background: #243889;
        border-radius: 5px;
        margin-left: 10px;
      }
      .code-btn-dis {
        background: #999;
        color: #fff;
      }
    }
    /deep/ .el-form-item__label {
      font-size: 15px;
      color: #555;
      padding-bottom: 5px;
      line-height: 25px;
    }
    /deep/ .el-input__inner {
      height: 44px;
      line-height: 44px;
      border-radius: 5px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
    }
    /deep/ .el-input__inner:focus {
      border-color: #243889;
    }
    .el-radio-group,
    .el-cascader {
      width: 100%;
    }
    /deep/ .el-radio {
      width: 40%;
      margin-top: 15px;
    }
    /deep/ .el-radio__label {
      font-size: 16px;
    }
    /deep/ .el-checkbox {
      width: 40%;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .logo {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
  .apply-wrap {
    width: 90%;
  }
}
@media only screen and (max-width: 767px) {
  .apply-wrap {
    padding-top: 35px;
    .el-form-item {
      width: 98%;
    }
  }
}
</style>